<div class="content">
  @if (showCategoriesSidebar) {
    <ppl-option-list-categories
      [categories]="normalizedSearchCategories"
      [value]="selectedCategory"
      (valueChange)="onSelectedCategoryChange($event)"
      [class.default-width]="listWidth === undefined"
      [style.max-height.px]="maxContainerHeight ? maxContainerHeight : null"
      [style.min-height.px]="showCategoriesSidebar ? maxContainerHeight || 200 : null"
      [style.width.px]="categoriesSidebarWidth"></ppl-option-list-categories>
  }

  <div
    #container
    class="container"
    [class.with-search]="showCategoriesSidebar"
    [style.max-height.px]="maxContainerHeight ? maxContainerHeight : null"
    [style.min-height.px]="showCategoriesSidebar ? maxContainerHeight || 200 : null"
    [style.width.px]="listWidth">
    @if (actionsTemplate) {
      <ng-container *ngTemplateOutlet="actionsTemplate"></ng-container>
    }
    @if (!!normalizedOptions.length) {
      <ppl-virtual-scroll
        #virtualScroll
        [data]="normalizedOptions"
        [dataTemplate]="rowTemplate"
        [minRowHeight]="25"
        [rowHeights]="rowHeights"
        [recordsContent]="recordsContent"
        (scrollChange)="onScrollChange($event)">
      </ppl-virtual-scroll>
    }
    @if ((displayNoResults && !displayLoading) || (displayAllCategories && !displayLoading && normalizedOptions.length === 0)) {
      <div
        class="no-results"
        [style.height.px]="optionTemplateRowHeight || 25">
        {{ intl.noResultsFound }}
      </div>
    }

    <ng-template
      #recordsContent
      let-scrollTop="scrollTop">
      @for (option of normalizedOptionsCategoriesOnly; track trackById($index, option)) {
        <div
          class="category"
          [style.top.px]="Math.max(option.offsetTop, scrollTop)">
          <div class="category-label">
            {{ option.value ? option.value.label : '' }}
          </div>
        </div>
      }
    </ng-template>

    <ng-template
      #rowTemplate
      let-option
      let-style="style">
      <div
        class="row"
        [ngStyle]="style">
        @if (option.kind === NormalizedOptionKind.Item) {
          <div
            class="item"
            [class.selected]="option.value.value === value"
            [attr.data-index]="option.index"
            (click)="onOptionClick(option.value, $event)"
            (mouseenter)="onOptionMouseEnter(option.value.value)">
            @if (optionTemplate) {
              <ng-container *ngTemplateOutlet="optionTemplate; context: { '\$implicit': option.value }"></ng-container>
            } @else {
              <div class="item-basic">
                @if (option.value.icon) {
                  <ppl-icon
                    class="item-icon"
                    [svgIcon]="option.value.icon"
                    width="14px"
                    height="14px"></ppl-icon>
                }
                <div
                  class="item-label"
                  [style.color]="option.value.color || null"
                  [attr.title]="option.value.labelInList || option.value.label || null">
                  {{ option.value.labelInList || option.value.label }}
                </div>
              </div>
            }
          </div>
        }
        @if (option.kind === NormalizedOptionKind.Loading) {
          <ppl-loading-overlay></ppl-loading-overlay>
        }
      </div>
    </ng-template>
  </div>
</div>

<div class="footer">
  @if (displayCreate) {
    <div
      class="create"
      (click)="onOptionCreate()">
      <ppl-icon
        svgIcon="color-add"
        width="18px"
        height="18px"></ppl-icon>
      <div class="create-label">
        {{ displayCreateOption }}
        <span class="create-label-token">"{{ createValue }}"</span>
      </div>
    </div>
  }
  @if (footerTemplate && !!options?.length) {
    <div class="footer-template">
      <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    </div>
  }
</div>
